import { AlertsDesktopView } from './AlertsDesktopView';

export function AlertsMobileView() {
  return <AlertsDesktopView />;
}
